import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { CollectionLeaderboardMoleculeReatom } from "./store.reatom"

export const useCollectionLeaderboardReatom = () => {
  const { getLeaderboardQuery } = useMolecule(
    CollectionLeaderboardMoleculeReatom,
  )
  return useSuspenseQuery(getLeaderboardQuery())
}
